import React from 'react';

const Icon74ChaiseOrientationRight = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <g>
      <path
        d="M602.4,255.49h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        transform="translate(1228.3 779.98) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M584.23,255.49h-261.65c-4.97,0-9,4.03-9,9v43.25h279.65v-43.25c0-4.97-4.03-9-9-9Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
    </g>
    <path
      d="M164.92,316.74v198.75c0,4.97,4.03,9,9,9h419.3v-216.75H173.92c-4.97,0-9,4.03-9,9Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon74ChaiseOrientationRight;
